module.exports = __webpack_public_path__ + "img/juvo-app-icon.c651c879.svg";